export enum LoginOrSignup {
  LOGIN = 'login',
  SIGNUP = 'signup',
}
